// extracted by mini-css-extract-plugin
export var productImage = "_us-0";